import styled from '@emotion/styled';
import { mediaDesktop, mediaMobile } from 'components/core/theme/breakpoints';

export const BodyWithNav = styled.div`
  min-height: 100%;

  /* room for header */
  padding-top: 64px;

  /* room for footer */
  padding-bottom: 98px;

  display: grid;
  grid-template-rows: 1fr auto;
  grid-template-columns: 1fr;
  grid-template-areas:
    'header'
    'body';

  ${mediaMobile} {
    padding-right: 16px;
    padding-left: 16px;
  }

  ${mediaDesktop} {
    padding-top: 140px;

    grid-template-columns: 280px minmax(720px, 1280px) auto;
    grid-template-areas: 'header body';
    padding-right: 24px;
  }
`;
export const BodyWithNavNoFooter = styled.div`
  min-height: 100%;

  /* room for header */
  padding-top: 64px;

  /* room for footer */
  padding-bottom: 16px;

  display: grid;
  grid-template-rows: 1fr auto;
  grid-template-columns: 1fr;
  grid-template-areas:
    'header'
    'body';

  ${mediaMobile} {
    padding-right: 16px;
    padding-left: 16px;
  }

  ${mediaDesktop} {
    padding-top: 140px;

    grid-template-columns: 280px minmax(720px, 1280px) auto;
    grid-template-areas: 'header body';
    padding-right: 24px;
  }
`;

export const BodyNoNav = styled(BodyWithNav)`
  grid-template-areas: 'body';

  ${mediaMobile} {
    display: block;
    padding-right: 24px;
    padding-left: 24px;
    width: 100%;
  }

  ${mediaDesktop} {
    grid-template-columns: auto 720px auto;
    grid-template-areas: '. body .';
  }
`;

export const BodyArea = styled.div<{ noPadding?: boolean }>`
  grid-area: body;

  ${mediaMobile} {
    padding-right: ${props => (props.noPadding ? '0' : '24px')};
    padding-left: ${props => (props.noPadding ? '0' : '24px')};
  }
`;
